import { SignaturePadComponent } from './signature-pad/signature-pad.component';
import { NgModule } from '@angular/core';

@NgModule({
    imports: [],
    declarations: [SignaturePadComponent],
    exports: [SignaturePadComponent]
})
export class SvcSignaturePadModule {}
